import React from 'react';
import { CircleDot, Droplet, Disc, Zap, AlertCircle, Search, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { services } from '../mockData';

const iconMap = {
  CircleDot,
  Droplet,
  Disc,
  Zap,
  AlertCircle,
  Search
};

export const Services = () => {
  const scrollToBooking = () => {
    const element = document.getElementById('booking');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="services" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-extrabold text-gray-900 mb-4">
            Our Services
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Comprehensive mobile automotive solutions for all your vehicle needs
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="group bg-gray-50 rounded-2xl p-8 hover:bg-white hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-red-100"
              >
                <div className="w-14 h-14 bg-red-100 rounded-xl flex items-center justify-center mb-6 group-hover:bg-red-600 transition-colors">
                  <IconComponent className="w-7 h-7 text-red-600 group-hover:text-white transition-colors" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{service.name}</h3>
                <p className="text-gray-600 mb-6">{service.description}</p>
                <button
                  onClick={scrollToBooking}
                  className="inline-flex items-center text-red-600 font-semibold hover:text-red-700 transition-colors group"
                >
                  Book Now
                  <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                </button>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center bg-gradient-to-r from-gray-50 to-slate-50 rounded-2xl p-8 border border-gray-200">
          <h3 className="text-2xl font-bold text-gray-900 mb-3">Need Something Else?</h3>
          <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
            We offer a wide range of automotive services. Contact us to discuss your specific needs.
          </p>
          <Button
            onClick={scrollToBooking}
            size="lg"
            className="bg-red-600 hover:bg-red-700 text-white"
          >
            Get a Custom Quote
          </Button>
        </div>
      </div>
    </section>
  );
};